import { LinkType } from '../../../core/types';
const defaultCtaLink = {
    href: '',
    text: '',
    anchor: '',
    linktype: LinkType.INTERNAL,
    class: '',
    title: '',
    querystring: '',
    id: '',
};
const getCtaWithDefaults = (ctaLink) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!ctaLink) {
        return defaultCtaLink;
    }
    return {
        href: (_a = ctaLink.href) !== null && _a !== void 0 ? _a : '',
        text: (_b = ctaLink.text) !== null && _b !== void 0 ? _b : '',
        anchor: (_c = ctaLink.anchor) !== null && _c !== void 0 ? _c : '',
        linktype: (_d = ctaLink.linktype) !== null && _d !== void 0 ? _d : LinkType.INTERNAL,
        class: (_e = ctaLink.class) !== null && _e !== void 0 ? _e : '',
        title: (_f = ctaLink.title) !== null && _f !== void 0 ? _f : '',
        querystring: (_g = ctaLink.querystring) !== null && _g !== void 0 ? _g : '',
        id: (_h = ctaLink.id) !== null && _h !== void 0 ? _h : '',
    };
};
export default getCtaWithDefaults;
